import {ageGroups, platforms, purchaseModels} from '../../../../utils/defaultsProvider';
import io from 'socket.io-client';
import USER_ROLES from '../../../../constants/userRoles.constants';
import APPLICATION_EVENTS from '../../../../constants/applicationEvents.constant';
import EVALUATION_STATUSES from "../../../../constants/evaluationStatuses.constant";

class StepBasicInfoController {
    constructor(
        commonDataService,
        evaluationService,
        pipeDriveService,
        userService,
        $window,
        $stateParams,
        $state,
        $q,
        $mdDialog,
        $mdToast,
        $location,
        $anchorScroll,
        $scope,
    ) {
        const self = this;

        self.allAgeGroups = ageGroups;
        self.allPlatforms = platforms;
        self.allPurchaseModels = purchaseModels;
        self.allKeywords = [];

        self.basic = {
            ageGroups: [],
            evaluators: [],
            managers: [],
            platforms: [],
            languages: [],
            purchaseModel: null,
            catalogueCoverIcon: '',
            keywords: self.allKeywords,
            looseImages: {
                items: [],
            },
        };

        self.isEditable = userService.isInRole(USER_ROLES.ROLE_ADMIN);
        self.isAdmin = userService.isInRole(USER_ROLES.ROLE_ADMIN);
        self.isManager = false;
        self.uploadError = {};
        self.keywordsInvalid = false;
        self.ageGroupsInvalid = false;
        self.$location = $location;
        self.$anchorScroll = $anchorScroll;
        self.q = $q;
        self.evaluationId = $stateParams.id;
        self.clientLinkEmpty = 'The link will appear after saving evaluation';
        self.deals = [];
        self.basicInfoForm = {};

        self.stateChangeCheck = true;

        const isMini = $state.includes('mini');

        const rootUrl = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');

        if (self.evaluationId) {
            evaluationService.getEvaluationData(self.evaluationId, isMini).then((data) => {
                self.isAdmin = userService.isInRole(USER_ROLES.ROLE_ADMIN);
                self.isManager = data.isManager;
                self.isEditable = (self.isAdmin || self.isManager);
                self.basic = {...self.basic, ...data};
                self.basicCopy = {...self.basic};
                const secret = data.secretId;
                const mini = data.isMini ? 'mini/' : '';
                if (secret) {
                    self.clientLinkUrl = rootUrl + '/client/' + mini + secret;
                    self.clientLinkEnabled = true;
                }
            });
        } else {
            evaluationService.currentEvaluation = {status: EVALUATION_STATUSES.NOT_STARTED};
        }

        self.uploadImage = () => {
            evaluationService.uploadPublishImage(self.newImage).then((e) => {
                this.basic.looseImages.items.push({
                    link: e.data.path,
                    subtitle: '',
                    published: true,
                });
            });
        };

        const socket = io(rootUrl, { path: '/wsapp', secure: true });
        socket.on('EVALUATION_UPDATED', (msg) => {
            if (msg.id === +self.evaluationId) {
                evaluationService.getEvaluationData(self.evaluationId, isMini)
                .then((data) => {
                    self.basic = data;
                    self.basicCopy = angular.copy(data);
                    const secret = data.secretId;
                    const isMini = data.isMini ? 'mini/' : '';
                    if (secret) {
                        self.clientLinkUrl = rootUrl + '/client/' + isMini + secret;
                        self.clientLinkEnabled = true;
                    }
                });
            }
        });

        this.canRemoveUser = (chip) => {
            return !(chip.id === userService.currentUser.id);
        };

        this.submitForm = ($form, data) => {
            self.basicInfoForm.$submitted = true;
            if($form.$valid) {
                this.handleSaveFormBasicClick($form, data, true);
            } else {
                angular.element(document.querySelector('input.ng-invalid-required')).focus();
                return false;
            }
        };

        this.handleSaveFormBasicClick = ($form, data, redirect) => {
            data.purchaseModels =
                (data.purchaseModels && !Array.isArray(data.purchaseModels))
                    ? [data.purchaseModels]
                    : [];

            evaluationService.sendBasicForm(data, self.basic.productImage, isMini).then((response) => {
                self.evaluationId = response.id;
                self.stateChangeCheck = !redirect;
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Basic information data has been saved successfully')
                        .position('top center')
                        .action('Hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass("success-toast")
                );
                if (redirect && response.status !== EVALUATION_STATUSES.NOT_STARTED) {
                    $window.location.href = `/mini/${self.evaluationId}/learning-goals/subject-area`;
                }
            }, (err) => {
                self.stateChangeCheck = true;
                $mdDialog.show(
                    $mdDialog.alert({
                        title: 'Some error occurred',
                        textContent: err.data ? err.data : `Your data has not been saved. Please try again.`,
                        ok: 'OK'
                    })
                );
            });
        };

        this.performExport = () => {
            this.exportInProgress = true;
            evaluationService.exportEvaluation(self.evaluationId, isMini)
                .then((data) => {
                    $mdDialog.show(
                        $mdDialog.confirm({
                            // Bug https://tracker.espeo.pl/issues/35568
                            // Chrome and Safari block opening new window tab in async callbacks
                            // https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari
                            // https://stackoverflow.com/questions/4663861/open-new-window-after-a-click-event-not-working-in-safari-chrome
                            // Solution is to do it inside click handler which requires overriding dialog controller
                            controller: function MdDialogController($mdDialog) {
                                this.$onInit = function() {
                                    var isPrompt = this.$type == 'prompt';
                                    if (isPrompt && this.initialValue) {
                                      this.result = this.initialValue;
                                    }

                                    this.hide = function() {
                                        window.open(data.url, '_blank');
                                        $mdDialog.hide(isPrompt ? this.result : true);
                                    };
                                    this.abort = function() {
                                        $mdDialog.cancel();
                                    };
                                    this.keypress = function($event) {
                                        if ($event.keyCode === $mdConstant.KEY_CODE.ENTER) {
                                            $mdDialog.hide(this.result);
                                        }
                                    };
                                };
                            }
                        })
                        .clickOutsideToClose(true)
                        .title('Export finished successfully')
                        .ok('Open Presentation')
                        .cancel('OK')
                    ).catch(() => {});
                }
              ).catch(
                (err) => {
                    $mdDialog.show(
                    $mdDialog.alert()
                      .clickOutsideToClose(true)
                      .title(err.data)
                      .ok('OK')
                  );
                }
              ).then(() => {
                  this.exportInProgress = false;
              });
        };

        this.exportEvaluation = (ev) => {
            if (this.basic.imagePath) {
                this.performExport();
            } else {
                $mdDialog.show(
                  $mdDialog.confirm()
                    .title('You are exporting an evaluation without product image')
                    .textContent('Do you want to proceed?')
                    .ariaLabel('Warning')
                    .targetEvent(ev)
                    .ok('Yes')
                    .cancel('Cancel')
                ).then(() => {
                    this.performExport();
                }).catch(() => {});
            }
        };

        this.search = (entity, term) => {
            if(term.replace(/[#.\\\/]/gi, '').length > 2) {
                return commonDataService.search(entity, term).then((res) => res.data);
            }
            return [];
        };

        this.findPipedriveData = () => {
            const deal = this.deals.find(e => e.title === this.basic.pipedriveDeal);

            if (deal) {
                pipeDriveService.getPipeDrivesByDeal(deal).then((res) => {
                    this.basic.companyName = res.data.org_name;
                    this.basic.pipedriveDealId = deal.id;
                    if (res.data.person_name) {
                        this.basic.contactPerson = res.data.person_name;
                    } else {
                        this.basic.contactPerson = '';
                    }
                    if (
                        res.data.person_id &&
                        res.data.person_id.email.length > 0 &&
                        res.data.person_id.email[0].value) {
                        this.basic.contactEmail = res.data.person_id.email[0].value;
                    } else {
                        this.basic.contactEmail = '';
                    }
                });
            }
        };

        this.pipedriveSearch = (term) => {
            if (term.length < 2) {
                return [];
            }

            return pipeDriveService.searchPipeDrives(term).then((data) => {
                this.deals = data.data;
                return data.data ? data.data.map(e => e.title) : [];
            });
        };

        this.evaluatorsSearch = (term) => {
            if (term.length < 2) {
                return [];
            }

            return userService.hintList(term).then((data) => {
                return data.filter(user => {
                    return !(self.basic.managers.find(manager => manager.id === user.id) ||
                    self.basic.evaluators.find(manager => manager.id === user.id) ||
                    user.id === userService.currentUser.id);
                }).map(user => {
                    return {
                        username: user.username,
                        id: user.id
                    };
                });
            });
        };

        this.sendEmail = ($form, data) => {
            if ($form.$valid) {
                self.stateChangeCheck = false;
                evaluationService.sendBasicForm(data, self.basic.productImage, isMini)
                    .then(() => {
                        evaluationService.sendEmailToClient(self.evaluationId, isMini);
                    },
                    (err) => {
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Something went wrong while sending the message')
                            .ok('OK')
                        );
                    }
                );
            }
        };

        this.onPurchaseModelsChange = () => {
            if (self.basic.purchaseModels && self.basic.purchaseModels.includes("Free")) {
                self.basic.priceInfo = null;
                return true;
            }
        };

        this.onPictureUpload = (fileEntity, obj, field, isList = false) => {
            if (isList) {
                fileEntity.forEach((file) => {
                    evaluationService.convertImageToBase64(file)
                        .then((res) => {
                            if (res) {
                                this.uploadError[field] = null;
                                (obj[field]).push({
                                    link: res.replace(/^.+base64,/, ''),
                                    subtitle: '',
                                    published: false,
                                });
                            }
                        })
                        .catch((error) => {
                            this.uploadError[field] = error.status;
                        });
                });
            } else {
                evaluationService.convertImageToBase64(fileEntity)
                    .then((res) => {
                        if (res) {
                            this.uploadError[field] = null;
                            obj[field] = res.replace(/^.+base64,/, '');
                        }
                    })
                    .catch((error) => {
                        this.uploadError[field] = error.status;
                    });
            }
        };

        this.onPageChange = (isAngular) => {
            const msg = "The page you want to leave has some unsaved changes. Do you want to leave?";
            return function(event) {
                if(isAngular && self.basicInfoForm) {
                    if (!self.basicInfoForm.$pristine && self.stateChangeCheck && !angular.equals(self.basic, self.basicCopy)) {
                        const answer = confirm(msg);
                        self.basicInfoForm.$submitted = true;
                        if (!answer) {
                            event.preventDefault();
                        } else {
                            self.handleSaveFormBasicClick(self.basicInfoForm, self.basic, false);
                        }
                    }
                } else if(self.basicInfoForm) {
                    if(!self.basicInfoForm.$pristine && self.stateChangeCheck) {
                        event.returnValue = msg;
                        return msg;
                    } else {
                        self.basicInfoForm.$submitted = true;
                    }
                }
            }
        };
    }

    toggleListMember(item, list) {
        const idx = list.indexOf(item);
        if (idx > -1) {
            list.splice(idx, 1);
        } else {
            list.push(item);
        }
    }

    isOnList(item, list) {
        return list.indexOf(item) > -1;
    }

    markFormAsSubmittedEvent() {
        this.$scope.$on(APPLICATION_EVENTS.MARK_FORM_AS_SUBMITTED, () => {
            this.basicInfoForm.$submitted = true;
        });
    }

    $onDestroy() {
        this.markFormAsSubmittedEvent();
        this.socket.disconnect();
        this.onPageChange(false);
    }
}

StepBasicInfoController.$inject = [
    'CommonDataService',
    'EvaluationService',
    'PipeDriveService',
    'UserService',
    '$window',
    '$stateParams',
    '$state',
    '$q',
    '$mdDialog',
    '$mdToast',
    '$location',
    '$anchorScroll',
    '$scope',
];

export default StepBasicInfoController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepBasicInfo/stepBasicInfoController.js